import { gsap } from "gsap";
import EasePack from "gsap/EasePack";
import GLightbox from 'glightbox'
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.install(window); // This will make everythng global.
gsap.registerPlugin(ScrollToPlugin);
